import { Star } from "lucide-react";


  const reviews = [
    {
      name: "さくら",
      location: "Tokyo, Japan",
      image: "https://randomuser.me/api/portraits/women/1.jpg",
      text: "このビタミンCサプリメントは本当に素晴らしいです！自然由来なので安心して飲めます。",
      rating: 5,
    },
    {
      name: "たけし",
      location: "Osaka, Japan",
      image: "https://randomuser.me/api/portraits/men/2.jpg",
      text: "毎日飲んでいます！風邪をひきにくくなり、肌の調子も良くなりました。",
      rating: 4,
    },
    {
      name: "ゆみ",
      location: "Kyoto, Japan",
      image: "https://randomuser.me/api/portraits/women/3.jpg",
      text: "合成ビタミンCではなく、オーガニックなのが気に入りました。体にも優しいし、味も良いです。",
      rating: 5,
    },
    {
      name: "健二",
      location: "Sapporo, Japan",
      image: "https://randomuser.me/api/portraits/men/4.jpg",
      text: "とても飲みやすく、家族全員で愛用しています！特に冬の季節には欠かせません。",
      rating: 5,
    },
    {
      name: "えり",
      location: "Nagoya, Japan",
      image: "https://randomuser.me/api/portraits/women/5.jpg",
      text: "体がスッキリして、肌の調子も良くなった感じがします。続けていきたいと思います。",
      rating: 4,
    },
    {
      name: "大輔",
      location: "Fukuoka, Japan",
      image: "https://randomuser.me/api/portraits/men/6.jpg",
      text: "忙しい毎日でも手軽にビタミンCを取れるのが嬉しい！味もとても良いです。",
      rating: 5,
    },
  ];
export default function CustomerFeedback() {
  return (
    <div className="py-12   px-6">
    <h2 className="text-7xl text-center font-extrabold text-gray-900   underline decoration-yellow-500">
    お客様の声
        </h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
        {reviews.map((review, index) => (
          <div key={index} className="bg-white  p-6 rounded-2xl border-4 border-yellow-400">
            <p className="text-xl text-gray-700  font-medium">「{review.text}」</p>
            <div className="flex items-center mt-4 space-x-2">
              {[...Array(review.rating)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <div className="mt-4 flex items-center space-x-4">
              <img src={review.image} alt={review.name} className="w-12 h-12 rounded-full border-2 border-yellow-400"/>
              <p className="text-gray-800  font-semibold">{review.name} ({review.location})</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
